import { useEffect, useState } from "react";
import { APIErrorResponse, isApiErrorResponse } from "features/api/utils/apiUtils.ts";
import { useLazyGetAutoCadFileQuery } from "../features/api/customQuotesApi.ts";

const useDownloadAutoCadFile = (quoteId?: string, revisionId?: number) => {
	const [dwgData, setDwgData] = useState<dwgData>({ blob: null, loading: false, error: null });
	const [trigger, { data: dwgApiData, error: dwgApiError }] = useLazyGetAutoCadFileQuery();

	const generateAutoCadFile = () => {
		trigger({ quoteId: quoteId, revisionId: revisionId });
		setDwgData((prev) => ({ ...prev, loading: true }));
	};

	const filePrefix = `Custom Quote ${revisionId}`;

	useEffect(() => {
		if (dwgApiData && "type" in dwgApiData) {
			setDwgData({ blob: dwgApiData, loading: false, error: null });
		}

		if (dwgApiError) {
			const error = isApiErrorResponse(dwgApiError) ? dwgApiError : new Error("Failed to generate DWG");
			setDwgData({ blob: null, loading: false, error: error });
		}
	}, [dwgApiData, dwgApiError]);

	useEffect(() => {
		if (dwgData.blob) {
			const url = window.URL.createObjectURL(dwgData.blob);
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", `${filePrefix}.dwg`);
			document.body.appendChild(link);
			link.click();
			setDwgData({ blob: null, loading: false, error: null });
		}
	}, [dwgData.blob, filePrefix]);

	return { dwgData, generateAutoCadFile };
};

interface dwgData {
	blob: Blob | null;
	loading: boolean;
	error: Error | APIErrorResponse | null | undefined;
}

export default useDownloadAutoCadFile;
